@use '~@cewe-designsystem-stylecomponents/button' as float-to-top-btn;

$spacing-bottom: calc(
  var(--footnote-height, 1px) + env(safe-area-inset-bottom, 1px) + var(--cwc-to-top-button-spacing-bottom, 1rem)
) !default;
$spacing-right: var(--cwc-to-top-button-spacing-right, 1.5rem) !default;
$hover-shift-offset: var(--cwc-to-top-button-hover-shift-offset, 0.1rem) !default;
$transition-duration: var(--cwc-to-top-button-transition-duration, 0.0125s) !default;
$z-index: var(--cwc-to-top-button-z-index, 0) !default;

:host {
  position: fixed;
  z-index: $z-index;
  right: $spacing-right;
  bottom: $spacing-bottom;
}

:host(:hover) {
  right: calc(#{$spacing-right} - #{$hover-shift-offset});
  bottom: calc(#{$spacing-bottom} - #{$hover-shift-offset});
  transition: all $transition-duration;
}

.float-to-top-button {
  --csc-button-lite--on-light--color: var(--float-to-top-button-color, #707070);
  --csc-button-lite--on-light--color-hover: var(--csc-button-lite--on-light--color);
  --csc-button-lite--on-light--color-active: var(--csc-button-lite--on-light--color);
  --csc-button-lite--on-light--color-focus: var(--csc-button-lite--on-light--color);

  --csc-button-lite--on-light--bg-color: var(--float-to-top-button-bg-color, #fff);
  --csc-button-lite--on-light--bg-color-hover: var(--csc-button-lite--on-light--bg-color);

  @include float-to-top-btn.button;
  @include float-to-top-btn.button--circle;
  @include float-to-top-btn.button-lite--on-light;

  border: 1px solid var(--csc-button-lite--on-light--color);
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.3);

  &:focus,
  &:focus-visible,
  &:hover,
  &:active {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }
}
